import { RootState } from "store/types"

export const getUserCredentials = (state: RootState) =>
    state.user?.user?.credentials ?? []
